var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3704 12.561C15.6941 12.4155 15.1591 12.7295 14.6854 13.0037C14.2003 13.2862 13.2779 14.0346 12.7491 13.843C10.042 12.7284 7.49582 10.3589 6.39364 7.64092C6.19939 7.10088 6.94421 6.17256 7.22469 5.68171C7.49686 5.20655 7.80435 4.66651 7.66411 3.98518C7.53737 3.37293 5.89813 1.28707 5.31847 0.716676C4.93619 0.339903 4.54456 0.132678 4.14254 0.0991872C2.63107 0.0342986 0.942996 2.05108 0.646935 2.53356C-0.094777 3.56236 -0.0906218 4.9313 0.659401 6.59119C2.46693 11.0497 9.30336 17.7782 13.7786 19.6537C14.6044 20.0399 15.3596 20.2335 16.038 20.2335C16.7018 20.2335 17.2929 20.0483 17.8008 19.6809C18.1842 19.4601 20.2836 17.6882 20.2285 16.1361C20.1953 15.7405 19.9886 15.3449 19.6167 14.9618C19.0505 14.3768 16.9781 12.6886 16.3704 12.561Z",
    fill: "#DB3251"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.99f38818ad86a1162ca9ab9c4b1fca16.svg";
export { ForwardRef as ReactComponent };